import * as colors from '../../../../common/colorConstants';
import styled from 'styled-components/macro';
import { mediumHeightScreens, smallScreens } from '../../../../common/fontElements';

const Title = styled.p`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: ${colors.black4};
  margin: 0;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 14px;
  }
`;

const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 250px;
`;

const SuccessIcon = styled.img`
  margin-bottom: 15px;
`;

const SuccessCard = styled.div`
  max-width: 340px;
  width: 100%;
  padding: 30px;
  margin-top: 20px;
  background-color: ${colors.lightGray7};
`;
const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: 'Roboto', sans-serif;
  color: ${colors.black4};
  line-height: 18px;
`;

const CardRowTitle = styled.div`
  font-weight: 500;
  font-size: 11px;
`;

const CardRowValue = styled.div`
  font-size: 11px;
`;

export { Title, SuccessWrapper, SuccessIcon, SuccessCard, CardRow, CardRowTitle, CardRowValue };
